import { useState } from 'react';
import { AssessmentBaseTab } from './quota/AssessmentBaseTab';
import { ContributionsTab } from './quota/ContributionsTab';
import { PolicyRunTab } from './quota/PolicyRunTab';
import { ScenarioCompareTab } from './quota/ScenarioCompareTab';
import { ModelActivityModal } from './quota/ModelActivityModal';

// Diocesan Quota Model — registrar workspace. Sub-tabs:
//   • Assessment Base — curate each church's per-year history (the engine input)
//   • Contributions   — load per-year contribution amounts across all churches
//   • Policy & Run    — edit/save a policy version, run it, read the stored schedule
//   • Scenarios       — model up to three ad-hoc scenarios side by side (nothing stored)

type QuotaTab = 'base' | 'contributions' | 'run' | 'scenarios';

const TABS: { id: QuotaTab; label: string }[] = [
  { id: 'base', label: 'Assessment Base' },
  { id: 'contributions', label: 'Contributions' },
  { id: 'run', label: 'Policy & Run' },
  { id: 'scenarios', label: 'Scenarios' },
];

export function QuotaPage() {
  const [tab, setTab] = useState<QuotaTab>('base');
  const [showActivity, setShowActivity] = useState(false);

  return (
    <div className="max-w-[1100px] mx-auto px-7 py-8">
      <div className="panel">
        <div
          className="panel-section"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            borderBottom: '1px solid var(--border)',
          }}
        >
          {TABS.map((t) => (
            <button
              key={t.id}
              className={`btn btn-sm ${tab === t.id ? '' : 'btn-ghost'}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
          {/* Read-only window into the open Quota Model app (who's taken part,
              what they've saved/run). Sits at the right of the tab row. */}
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => setShowActivity(true)}
            style={{ marginLeft: 'auto' }}
            title="See who has taken part in the public Quota Model and what they've run"
          >
            Model Activity
          </button>
        </div>

        {tab === 'base' && <AssessmentBaseTab />}
        {tab === 'contributions' && (
          <div className="panel-section">
            <ContributionsTab />
          </div>
        )}
        {tab === 'run' && (
          <div className="panel-section">
            <PolicyRunTab />
          </div>
        )}
        {tab === 'scenarios' && (
          <div className="panel-section">
            <ScenarioCompareTab />
          </div>
        )}
      </div>

      {showActivity && <ModelActivityModal onClose={() => setShowActivity(false)} />}
    </div>
  );
}
